import { CHANNELS_AVAILABLE } from "../../channels/constants";

export const COMMENT_TYPE = {
  EXTERNAL: "external",
  INTERNAL: "internal",
};

export const VIEW_COMMENT_TYPE = {
  COMMENTS: "comments",
  MESSAGES: "messages",
};

export const MAX_CHARACTERS_REPLY_CHANNEL = {
  [CHANNELS_AVAILABLE.TWITTER]: 280,
};

export const MAX_OUTGOINGS_MESSAGES_CHANNEL = {
  [CHANNELS_AVAILABLE.MERCADO_LIBRE]: 1,
};

export const COMMENT_STATUS_TYPES = {
  FAILED: "failed",
  LOADING: "loading",
  SENT: "sent",
  DELIVERED: "delivered",
  UNDELIVERED: "undelivered",
  READ: "read",
  QUEUED: "queued",
};

export const COMMENT_DIRECTION_TYPES = {
  OUTGOING: "outgoing",
  INCOMING: "incoming",
};
